import {
  ADD_CONTACTED_COUNT_REQUEST,
  ADD_CONTACTED_COUNT_SUCCESS,
  ADD_CONTACTED_COUNT_FAILURE,
  RESET_MESSAGE,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const addContactedCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CONTACTED_COUNT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_CONTACTED_COUNT_SUCCESS:
      console.log("us", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case ADD_CONTACTED_COUNT_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_MESSAGE:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default addContactedCountReducer;
